module.exports = __webpack_public_path__ + "static/media/Maf_Axxis.768c2e03.jpg";